import React from 'react';
import {
  Sidebar,
  IconVideo,
  IconFilm,
  useUserinfo,
  RemoteSession,
} from '@mss/mss-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWaveSquare } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

type Props = {
  session: RemoteSession | undefined;
};

export default function EditSidebar({ session }: Props) {
  const [t] = useTranslation(['remoteAccess']);
  const [hasPermission] = useUserinfo();
  if (!session) return null;
  return (
    <Sidebar>
      <Sidebar.Item
        title={t('Details')}
        icon={<FontAwesomeIcon icon={faWaveSquare} size={'sm'} />}
        url="details"
        data-ta="Details"
      />
      {hasPermission('observer_remotesession') &&
        session.status === 'active' && (
          <Sidebar.Item
            title={t('Viewer')}
            icon={
              <IconVideo
                stroke={'currentColor'}
                height={15}
                viewBox="7 0 24 24"
              />
            }
            url="viewer"
            data-ta="SessionViewer"
          />
        )}
      {hasPermission('view_recording_remotesession') &&
        session.is_recorded &&
        session.status !== 'active' && (
          <Sidebar.Item
            title={t('Recording')}
            icon={
              <IconFilm
                stroke={'currentColor'}
                height={15}
                viewBox="7 0 24 24"
              />
            }
            url="recording"
            data-ta="SessionRecording"
          />
        )}
    </Sidebar>
  );
}
